import { DataTableColumnHeader } from 'common/data-table-column-header';
import {
  booleanCell,
  checkIconWithValueCell,
  dateTimeCell,
  linkCell,
} from 'utils/cell-formatter';
import { cloudflareCdn } from 'utils/image';

export const columnsGenerator = () => [
  {
    accessorKey: 'id',
    header: '',
    cell: ({ getValue }) =>
      linkCell({ getValue, path: '/admin/fund-managers' }),
  },
  {
    accessorKey: 'ranking',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Ranking" />
    ),
    meta: { className: 'text-center w-20' },
  },
  {
    accessorKey: 'code',
    header: 'Code',
  },
  {
    accessorKey: 'slug',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Slug" />
    ),
  },
  {
    accessorKey: 'fmarket_id',
    header: 'Fmarket ID',
    cell: checkIconWithValueCell,
  },
  {
    accessorKey: 'nhsv_code',
    header: 'NHSV Code',
    cell: checkIconWithValueCell,
  },
  {
    accessorKey: 'logo',
    header: 'Logo',
    meta: {
      className: 'text-center',
    },
    cell: ({ getValue }) => {
      const logoUrl = getValue();
      return logoUrl ? (
        <img width={80} src={cloudflareCdn(logoUrl, 80)} />
      ) : (
        '-'
      );
    },
  },
  {
    accessorKey: 'name',
    header: 'Name',
  },

  {
    accessorKey: 'is_econtract_required',
    header: 'Ký trước khi mua',
    meta: {
      className: 'text-center',
    },
    cell: booleanCell,
  },
  {
    accessorKey: 'created_at',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Created" />
    ),
    cell: dateTimeCell,
  },
  {
    accessorKey: 'updated_at',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Updated" />
    ),
    cell: dateTimeCell,
  },
];
